export default __webpack_public_path__ + "static/media/walletconnect.491f03b7.svg";